(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["filters"] && !Shopify.designMode) return;
  try {
    // Mobile filter two-column layout switching
  (function() {
    let isInitialized = false;
    let eventHandler = null;

    // Helper function to check if a label is the hidden gender filter
    function isHiddenGenderFilter(label) {
      if (!label) return false;
      const ariaLabel = label.getAttribute('aria-label');
      return ariaLabel && ariaLabel.toLowerCase() === 'gender' && 
             window.getComputedStyle(label).display === 'none';
    }

    // Helper function to get the first visible filter label
    function getFirstVisibleFilterLabel() {
      const labels = document.querySelectorAll('.facets__filter-label-mobile');
      for (let i = 0; i < labels.length; i++) {
        const label = labels[i];
        const computedStyle = window.getComputedStyle(label);
        if (computedStyle.display !== 'none' && !isHiddenGenderFilter(label)) {
          return label;
        }
      }
      return labels[0] || null; // Fallback to first label if all are hidden
    }

    function handleFilterLabelClick(e) {
      const label = e.target.closest('.facets__filter-label-mobile');
      if (!label) return;

      e.preventDefault();
      e.stopPropagation();
      const filterId = label.dataset.filterId;

      // Get fresh references to all labels and panels
      const allLabels = document.querySelectorAll('.facets__filter-label-mobile');
      const allPanels = document.querySelectorAll('.facets__filter-values-panel');

      // Remove active class from all labels
      allLabels.forEach(function(l) {
        l.classList.remove('facets__filter-label-mobile--active');
      });

      // Add active class to clicked label
      label.classList.add('facets__filter-label-mobile--active');

      // Hide all panels
      allPanels.forEach(function(panel) {
        panel.classList.remove('facets__filter-values-panel--active');
      });

      // Show selected panel
      const targetPanel = document.getElementById(filterId);
      if (targetPanel) {
        targetPanel.classList.add('facets__filter-values-panel--active');
      }
    }

    function initMobileFilterSwitching() {
      const filterLabelsContainer = document.querySelector('.facets__filter-labels-mobile');
      if (!filterLabelsContainer) {
        isInitialized = false;
        return;
      }

      // Remove existing listener if it exists
      if (eventHandler) {
        filterLabelsContainer.removeEventListener('click', eventHandler);
        eventHandler = null;
      }

      // Use event delegation - attach listener to parent container
      eventHandler = handleFilterLabelClick;
      filterLabelsContainer.addEventListener('click', eventHandler);
      
      // Ensure the correct filter is active on initialization
      // Check if the currently active label is the hidden gender filter
      const activeLabel = document.querySelector('.facets__filter-label-mobile--active');
      if (activeLabel && isHiddenGenderFilter(activeLabel)) {
        // If active label is hidden gender filter, activate first visible filter instead
        const firstVisible = getFirstVisibleFilterLabel();
        if (firstVisible) {
          // Remove active from all labels
          document.querySelectorAll('.facets__filter-label-mobile').forEach(function(label) {
            label.classList.remove('facets__filter-label-mobile--active');
          });
          
          // Activate first visible label
          firstVisible.classList.add('facets__filter-label-mobile--active');
          
          // Activate corresponding panel
          const filterId = firstVisible.getAttribute('data-filter-id');
          if (filterId) {
            document.querySelectorAll('.facets__filter-values-panel').forEach(function(panel) {
              panel.classList.remove('facets__filter-values-panel--active');
            });
            const targetPanel = document.getElementById(filterId);
            if (targetPanel) {
              targetPanel.classList.add('facets__filter-values-panel--active');
            }
          }
        }
      }
      
      isInitialized = true;
    }

    function restoreActiveMobileFilterLabel() {
      const storedFilterId = sessionStorage.getItem('activeMobileFilterLabel');
      const storedFilterIndex = sessionStorage.getItem('activeMobileFilterIndex');
      
      if (storedFilterId || storedFilterIndex !== null) {
        // Check if the drawer is open (if it exists)
        const drawer = document.querySelector('#filters-drawer');
        const dialog = drawer ? drawer.querySelector('dialog') : null;
        const isDrawerOpen = !drawer || (dialog && dialog.hasAttribute('open'));
        
        // Only restore if drawer is open or doesn't exist (desktop view)
        if (isDrawerOpen) {
          // Try to find the label by filter ID first
          let activeLabel = null;
          if (storedFilterId) {
            activeLabel = document.querySelector(`.facets__filter-label-mobile[data-filter-id="${storedFilterId}"]`);
          }
          
          // Fallback to filter index if filter ID doesn't work
          if (!activeLabel && storedFilterIndex !== null) {
            const labels = document.querySelectorAll('.facets__filter-label-mobile');
            const index = parseInt(storedFilterIndex, 10);
            if (labels[index]) {
              activeLabel = labels[index];
            }
          }
          
          // Check if the restored label is the hidden gender filter
          if (activeLabel && isHiddenGenderFilter(activeLabel)) {
            // If it's the hidden gender filter, use the first visible filter instead
            activeLabel = getFirstVisibleFilterLabel();
          }
          
          if (activeLabel) {
            // Remove active class from all labels
            document.querySelectorAll('.facets__filter-label-mobile').forEach(function(label) {
              label.classList.remove('facets__filter-label-mobile--active');
            });
            
            // Add active class to the stored label
            activeLabel.classList.add('facets__filter-label-mobile--active');
            
            // Get the corresponding panel and activate it
            const filterId = activeLabel.getAttribute('data-filter-id');
            if (filterId) {
              // Hide all panels
              document.querySelectorAll('.facets__filter-values-panel').forEach(function(panel) {
                panel.classList.remove('facets__filter-values-panel--active');
              });
              
              // Show the active panel
              const targetPanel = document.getElementById(filterId);
              if (targetPanel) {
                targetPanel.classList.add('facets__filter-values-panel--active');
              }
            }
          }
        }
      }
    }

    function reinitializeAfterFilterUpdate() {
      // Wait a bit for DOM to update after filter changes
      setTimeout(function() {
        initMobileFilterSwitching();
        // Restore the active filter label after reinitializing
        restoreActiveMobileFilterLabel();
      }, 50);
      
      // Also try again after a longer delay to ensure everything is ready
      setTimeout(function() {
        initMobileFilterSwitching();
        restoreActiveMobileFilterLabel();
      }, 200);
    }

    // Initialize on load
    function initialize() {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function() {
          initMobileFilterSwitching();
          // Re-initialize after a short delay to ensure drawer is rendered
          setTimeout(initMobileFilterSwitching, 500);
        });
      } else {
        initMobileFilterSwitching();
        // Re-initialize after a short delay to ensure drawer is rendered
        setTimeout(initMobileFilterSwitching, 500);
      }
    }

    initialize();

    // Re-initialize on section load
    document.addEventListener('shopify:section:load', function() {
      setTimeout(initMobileFilterSwitching, 100);
    });

    // Re-initialize when filters drawer is opened
    function setupDrawerListeners() {
      const drawer = document.querySelector('#filters-drawer');
      if (!drawer) return;

      const dialog = drawer.querySelector('dialog');
      if (!dialog) return;

      // Listen for when drawer opens
      dialog.addEventListener('transitionend', function() {
        if (dialog.hasAttribute('open')) {
          setTimeout(initMobileFilterSwitching, 100);
        }
      });

      // Also listen for attribute changes on the dialog
      const dialogObserver = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          if (mutation.type === 'attributes' && mutation.attributeName === 'open') {
            if (dialog.hasAttribute('open')) {
              setTimeout(initMobileFilterSwitching, 200);
            }
          }
        });
      });

      dialogObserver.observe(dialog, {
        attributes: true,
        attributeFilter: ['open']
      });
    }

    // Listen for filter update events (from facets system)
    document.addEventListener('facet:updated', reinitializeAfterFilterUpdate);
    document.addEventListener('filter:updated', reinitializeAfterFilterUpdate);
    document.addEventListener('filter:update', reinitializeAfterFilterUpdate);
    
    // Listen for drawer restoration event (from facets.js)
    document.addEventListener('filters-drawer-restored', function() {
      reinitializeAfterFilterUpdate();
    });
    
    // Use MutationObserver to detect when drawer content changes
    const observer = new MutationObserver(function(mutations) {
      const drawer = document.querySelector('.facets--drawer');
      if (drawer && drawer.hasAttribute('open')) {
        // Check if content actually changed
        const hasContentChanges = mutations.some(function(mutation) {
          return mutation.type === 'childList' && mutation.addedNodes.length > 0;
        });
        if (hasContentChanges) {
          reinitializeAfterFilterUpdate();
        }
      }
    });

    // Observe changes to the drawer
    function startObserving() {
      const drawer = document.querySelector('#filters-drawer');
      if (drawer) {
        observer.observe(drawer, {
          childList: true,
          subtree: true
        });
        setupDrawerListeners();
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', startObserving);
    } else {
      startObserving();
    }

    // Also re-initialize when drawer opens (using a more reliable method)
    document.addEventListener('click', function(e) {
      // Check if filter drawer button was clicked
      const filterButton = e.target.closest('[on\\:click*="#filters-drawer/showDialog"]') || 
                           e.target.closest('.facets-toggle__button') ||
                           e.target.closest('.mobile-sticky-filter-sort-bar__button--filter');
      if (filterButton) {
        // Re-initialize after drawer opens
        setTimeout(function() {
          initMobileFilterSwitching();
        }, 400);
      }
    }, true); // Use capture phase to catch events early
  })();

  // Handle button color changes when dialogs open/close
  (function() {
    const filterDrawer = document.querySelector('#filters-drawer');
    const sortPopup = document.querySelector('#mobile-sort-popup');
    const sortButton = document.querySelector('.mobile-sticky-filter-sort-bar__button--sort');
    const filterButton = document.querySelector('.mobile-sticky-filter-sort-bar__button--filter');

    function updateButtonColors() {
      const filterDialog = filterDrawer?.querySelector('dialog');
      const sortDialog = sortPopup?.querySelector('dialog');
      
      const isFilterOpen = filterDialog?.hasAttribute('open');
      const isSortOpen = sortDialog?.hasAttribute('open');

      // Toggle classes on buttons
      if (sortButton) {
        if (isFilterOpen) {
          sortButton.classList.add('button-white');
        } else {
          sortButton.classList.remove('button-white');
        }
      }

      if (filterButton) {
        if (isSortOpen) {
          filterButton.classList.add('button-white');
        } else {
          filterButton.classList.remove('button-white');
        }
      }
    }

    // Watch for dialog open/close events
    function setupDialogWatchers() {
      const filterDialog = filterDrawer?.querySelector('dialog');
      const sortDialog = sortPopup?.querySelector('dialog');

      if (filterDialog) {
        // Watch for open attribute changes on filter dialog
        const filterObserver = new MutationObserver(function(mutations) {
          mutations.forEach(function(mutation) {
            if (mutation.type === 'attributes' && mutation.attributeName === 'open') {
              updateButtonColors();
            }
          });
        });
        filterObserver.observe(filterDialog, {
          attributes: true,
          attributeFilter: ['open']
        });
      }

      if (sortDialog) {
        // Watch for open attribute changes on sort dialog
        const sortObserver = new MutationObserver(function(mutations) {
          mutations.forEach(function(mutation) {
            if (mutation.type === 'attributes' && mutation.attributeName === 'open') {
              updateButtonColors();
            }
          });
        });
        sortObserver.observe(sortDialog, {
          attributes: true,
          attributeFilter: ['open']
        });
      }

      // Initial check
      updateButtonColors();
    }

    // Initialize when DOM is ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', setupDialogWatchers);
    } else {
      setupDialogWatchers();
    }

    // Also re-initialize after section updates
    document.addEventListener('shopify:section:load', function() {
      setTimeout(setupDialogWatchers, 100);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["strap-color-variant"] && !Shopify.designMode) return;
  try {
    class StrapColorVariant extends HTMLElement {
    connectedCallback() {
      this.addEventListener('change', this.#syncSelected);
      this.addEventListener('error', this.#hideMissingImage, true);
      const section = this.closest('.shopify-section, dialog');
      section?.addEventListener('variant:selected', this.#onVariantSelected);
      section?.addEventListener('variant:update', this.#onVariantUpdate);
      this.#syncSelected();
    }

    disconnectedCallback() {
      this.removeEventListener('change', this.#syncSelected);
      this.removeEventListener('error', this.#hideMissingImage, true);
      const section = this.closest('.shopify-section, dialog');
      section?.removeEventListener('variant:selected', this.#onVariantSelected);
      section?.removeEventListener('variant:update', this.#onVariantUpdate);
      clearTimeout(this.refreshTimeout);
    }

    #onVariantSelected = () => {
      clearTimeout(this.refreshTimeout);
      this.classList.add('strap-color-variant-refresh-state');
      this.setAttribute('aria-busy', 'true');
      this.refreshTimeout = setTimeout(this.#finishRefresh, 10000);
    };

    #onVariantUpdate = (event) => {
      const productId = event.detail?.data?.productId;
      if (productId && this.dataset.productId && productId !== this.dataset.productId) return;

      const html = event.detail?.data?.html;
      if (!html) return;

      const next = html.querySelector(`strap-color-variant[data-block-id="${this.dataset.blockId}"]`);
      if (!next) return;

      const checkedId = this.querySelector('input:checked')?.value;
      this.innerHTML = next.innerHTML;

      if (checkedId) {
        const sameChoice = this.querySelector(`input[value="${checkedId}"]`);
        if (sameChoice instanceof HTMLInputElement && !sameChoice.disabled) sameChoice.checked = true;
      }

      this.#syncSelected();
      this.#finishRefresh();
    };

    #finishRefresh = () => {
      clearTimeout(this.refreshTimeout);
      this.classList.remove('strap-color-variant-refresh-state');
      this.removeAttribute('aria-busy');
    };

    #hideMissingImage = (event) => {
      const image = event.target;
      if (!(image instanceof HTMLImageElement) || !this.contains(image)) return;

      const option = image.closest('.variant-option__button-label');
      if (!option) return;

      const input = option.querySelector('input');
      const wasChecked = input instanceof HTMLInputElement && input.checked;
      option.hidden = true;
      if (wasChecked && input instanceof HTMLInputElement) input.checked = false;

      if (wasChecked) {
        const next = this.querySelector('.variant-option__button-label:not([hidden]) input:not(:disabled)');
        if (next instanceof HTMLInputElement) next.checked = true;
      }

      this.#syncSelected();
    };

    #syncSelected = () => {
      const selected = this.querySelector('[data-strap-color-selected]');
      const checked = this.querySelector('.variant-option__button-label:not([hidden]) input:checked');
      const strapSku = checked instanceof HTMLInputElement ? (checked.dataset.sku || '').trim() : '';

      if (selected) {
        selected.textContent = checked instanceof HTMLInputElement ? checked.dataset.colorName || '' : '';
      }

      const scope = this.closest('.shopify-section, dialog') || document;
      const personaliseRoot = scope.querySelector('.personalise-spare-strap');
      if (personaliseRoot instanceof HTMLElement) {
        personaliseRoot.setAttribute('data-personalise-variant-sku', strapSku);
      }
    };
  }

  if (!customElements.get('strap-color-variant')) {
    customElements.define('strap-color-variant', StrapColorVariant);
  }
  } catch(e) { console.error(e); }
})();

})();
